<template>
  <div class="sidebar">
    <SideMenu
      :size="size"
      @on-shared-group="onSharedGroup"
      @change-modal-view="changeModalView"
      @on-logout="onLogout"
    />
  </div>
</template>

<script>
import SideMenu from "@/components/molecules/common/SideMenu.vue"

export default {
  name: "AppSidebar",
  components: {
    SideMenu,
  },
  props: {
    size: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },

  emits: [
    "on-shared-group",
    "change-modal-view",
    "on-logout",
  ],
  data: () => ({
    //
  }),

  methods: {
    onSharedGroup() {
      this.$emit('on-shared-group')
    },
    changeModalView(value) {
      this.$emit('change-modal-view', value)
    },
    onLogout() {
      this.$emit('on-logout')
    },
  }
}
</script>
